import { useClientTranslation } from '@/lib/core/i18n';

export interface ProductMetaRowProps {
  color?: string;
  size?: string;
  quantity?: number;
}

/** Renders "Colour • Size • Qty: N" with a small dot separator. */
export function ProductMetaRow({ color, size, quantity }: ProductMetaRowProps) {
  const t = useClientTranslation();

  const parts: string[] = [];
  if (color) parts.push(color);
  if (size) parts.push(size);
  if (typeof quantity === 'number') {
    parts.push(t('App.Shop.Wishlist.QuantityAbbr', { count: quantity }));
  }

  if (parts.length === 0) return null;

  return (
    <p className="font-pp-neue-montreal text-jncquoi-neutral-700 flex items-center gap-2 text-[12px] leading-none font-normal tracking-[0.5px]">
      {parts.map((part, index) => (
        <span key={part} className="flex items-center gap-2">
          {index > 0 && (
            <span
              className="bg-jncquoi-neutral-500 inline-block size-1 shrink-0 rounded-full"
              aria-hidden="true"
            />
          )}
          {part}
        </span>
      ))}
    </p>
  );
}
